import { render, staticRenderFns } from "./MigrateNoticeModal.vue?vue&type=template&id=b2fb73b8&"
import script from "./MigrateNoticeModal.vue?vue&type=script&lang=js&"
export * from "./MigrateNoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./MigrateNoticeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports